module.exports = __webpack_public_path__ + "img/crown-small.205cb928.svg";